const purple = {
  50: '#ededfc',
  100: '#dbd9ff',
  300: '#beb3ff',
  500: '#a189ff',
  600: '#642294',
  700: '#7b6cd3',
  800: '#7247b5',
  900: '#5c2c8f',
  1000: '#5c2d8f',
  1100: '#ee479a',
  1200: '#232A54',
};

export default purple;
